// extracted by mini-css-extract-plugin
export default {"inbound_document_navbar_style":"ckHAJIX4ci+AP4rYJFkJIg=="};